/* CITRINA — animaciones e interacciones (vanilla, sin librerías) */
(function () {
  if (window.__ctCargado) return;
  window.__ctCargado = true;
  window.ctReady = true;

  var sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Titulares palabra a palabra ---------- */
  function partirTexto(raiz) {
    raiz.querySelectorAll('[data-ct-split]:not([data-ct-split-hecho])').forEach(function (el) {
      el.setAttribute('data-ct-split-hecho', '');
      var i = 0;
      var recorrer = function (nodo) {
        Array.prototype.slice.call(nodo.childNodes).forEach(function (hijo) {
          if (hijo.nodeType === 3) {
            var trozos = hijo.textContent.split(/(\s+)/);
            var frag = document.createDocumentFragment();
            trozos.forEach(function (t) {
              if (!t) return;
              if (/^\s+$/.test(t)) { frag.appendChild(document.createTextNode(' ')); return; }
              var w = document.createElement('span');
              w.className = 'ct-w';
              var s = document.createElement('span');
              s.style.setProperty('--i', i++);
              s.textContent = t;
              w.appendChild(s);
              frag.appendChild(w);
            });
            nodo.replaceChild(frag, hijo);
          } else if (hijo.nodeType === 1 && hijo.tagName !== 'BR') {
            recorrer(hijo);
          }
        });
      };
      recorrer(el);
    });
  }

  /* ---------- Un único observador para todas las entradas ---------- */
  var observador = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('ct-visible');
            observador.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 })
    : null;

  function initReveals(raiz) {
    var els = raiz.querySelectorAll('[data-ct-reveal], [data-ct-split], [data-ct-unveil], .ct-ritual__linea');
    var vh = window.innerHeight;
    els.forEach(function (el) {
      if (!observador || sinMovimiento) { el.classList.add('ct-visible'); return; }
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0 && window.scrollY < 50) {
        requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('ct-visible'); }); });
        return;
      }
      observador.observe(el);
    });
  }

  /* ---------- Parallax suave ---------- */
  var parallaxEls = [];
  function initParallax(raiz) {
    if (sinMovimiento) return;
    raiz.querySelectorAll('[data-ct-parallax]').forEach(function (el) {
      if (parallaxEls.indexOf(el) === -1) parallaxEls.push(el);
    });
  }
  var pendiente = false;
  function pintarParallax() {
    pendiente = false;
    var vh = window.innerHeight;
    parallaxEls.forEach(function (el) {
      if (!el.isConnected) return;
      var r = el.parentElement.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      var f = parseFloat(el.getAttribute('data-ct-parallax')) || 0.1;
      var centro = r.top + r.height / 2 - vh / 2;
      el.style.transform = 'translate3d(0,' + (centro * -f).toFixed(1) + 'px,0)';
    });
    pintarProgresos();
  }
  function alScroll() {
    if (!pendiente) { pendiente = true; requestAnimationFrame(pintarParallax); }
  }
  window.addEventListener('scroll', alScroll, { passive: true });
  window.addEventListener('resize', alScroll);

  /* ---------- Línea de progreso de la sección vitamina ---------- */
  var progresos = [];
  function initVitamina(raiz) {
    raiz.querySelectorAll('.ct-vita__lista').forEach(function (lista) {
      if (progresos.indexOf(lista) === -1) progresos.push(lista);
    });
  }
  function pintarProgresos() {
    var vh = window.innerHeight;
    progresos.forEach(function (lista) {
      if (!lista.isConnected) return;
      var r = lista.getBoundingClientRect();
      var p = (vh * 0.6 - r.top) / r.height;
      p = Math.max(0, Math.min(1, p));
      lista.style.setProperty('--p', p.toFixed(3));
      lista.querySelectorAll('.ct-vita__item').forEach(function (item) {
        var ir = item.getBoundingClientRect();
        item.classList.toggle('ct-activo', ir.top < vh * 0.6);
      });
    });
  }

  /* ---------- Inclinación 3D al pasar el ratón ---------- */
  function initTilt(raiz) {
    if (sinMovimiento || window.matchMedia('(hover: none)').matches) return;
    raiz.querySelectorAll('[data-ct-tilt]').forEach(function (el) {
      if (el.__ctTilt) return;
      el.__ctTilt = true;
      var fuerza = parseFloat(el.getAttribute('data-ct-tilt')) || 6;
      el.addEventListener('pointermove', function (ev) {
        var r = el.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - 0.5;
        var y = (ev.clientY - r.top) / r.height - 0.5;
        el.style.transform = 'perspective(900px) rotateX(' + (-y * fuerza).toFixed(2) + 'deg) rotateY(' + (x * fuerza).toFixed(2) + 'deg) translateY(-6px)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  /* ---------- Botón magnético ---------- */
  function initMagnetico(raiz) {
    if (sinMovimiento || window.matchMedia('(hover: none)').matches) return;
    raiz.querySelectorAll('[data-ct-magnetico]').forEach(function (el) {
      if (el.__ctMag) return;
      el.__ctMag = true;
      el.addEventListener('pointermove', function (ev) {
        var r = el.getBoundingClientRect();
        var x = ev.clientX - r.left - r.width / 2;
        var y = ev.clientY - r.top - r.height / 2;
        el.style.transform = 'translate(' + (x * 0.18).toFixed(1) + 'px,' + (y * 0.3).toFixed(1) + 'px)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  /* ---------- Acordeones (FAQ y producto) ---------- */
  function initAcordeones(raiz) {
    raiz.querySelectorAll('[data-ct-acordeon]').forEach(function (grupo) {
      if (grupo.__ctAc) return;
      grupo.__ctAc = true;
      var unico = grupo.getAttribute('data-ct-acordeon') === 'unico';
      grupo.querySelectorAll('.ct-faq__pregunta').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.ct-faq__item');
          var abrir = !item.classList.contains('ct-abierto');
          if (unico) {
            grupo.querySelectorAll('.ct-faq__item.ct-abierto').forEach(function (o) {
              o.classList.remove('ct-abierto');
              o.querySelector('.ct-faq__pregunta').setAttribute('aria-expanded', 'false');
            });
          }
          item.classList.toggle('ct-abierto', abrir);
          btn.setAttribute('aria-expanded', abrir ? 'true' : 'false');
        });
      });
    });
  }

  /* ---------- Página de producto ---------- */
  function formatearDinero(cents, formato) {
    var valor = (cents / 100).toFixed(2);
    var conComa = valor.replace('.', ',');
    var sinDec = Math.round(cents / 100).toString();
    var miles = function (n) { return n.replace(/\B(?=(\d{3})+(?!\d))/g, '.'); };
    var partes = conComa.split(',');
    return (formato || '{{amount_with_comma_separator}} €')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, miles(partes[0]) + ',' + partes[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, miles(sinDec))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, sinDec.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount\s*\}\}/, valor.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  function initProducto(raiz) {
    raiz.querySelectorAll('[data-ct-pdp]').forEach(function (pdp) {
      if (pdp.__ctPdp) return;
      pdp.__ctPdp = true;

      var slides = pdp.querySelector('.ct-pdp__slides');
      var minis = pdp.querySelectorAll('.ct-pdp__mini');
      var contador = pdp.querySelector('[data-ct-contador]');
      var total = slides ? slides.children.length : 0;

      function irA(i, suave) {
        if (!slides || !total) return;
        i = (i + total) % total;
        slides.scrollTo({ left: slides.clientWidth * i, behavior: suave === false ? 'auto' : 'smooth' });
      }
      function actual() { return slides ? Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth)) : 0; }
      if (slides) {
        var t;
        slides.addEventListener('scroll', function () {
          clearTimeout(t);
          t = setTimeout(function () {
            var i = actual();
            minis.forEach(function (m, k) { m.classList.toggle('ct-activo', k === i); });
            if (contador) contador.textContent = (i + 1) + ' / ' + total;
            slides.querySelectorAll('.ct-zoom').forEach(function (z) { z.classList.remove('ct-zoom'); });
          }, 60);
        }, { passive: true });
        slides.querySelectorAll('.ct-pdp__slide').forEach(function (s) {
          s.addEventListener('click', function (ev) {
            if (window.matchMedia('(hover: none)').matches) return;
            var img = s.querySelector('img');
            if (!s.classList.contains('ct-zoom')) {
              var r = s.getBoundingClientRect();
              img.style.transformOrigin = ((ev.clientX - r.left) / r.width * 100) + '% ' + ((ev.clientY - r.top) / r.height * 100) + '%';
            }
            s.classList.toggle('ct-zoom');
          });
          s.addEventListener('pointermove', function (ev) {
            if (!s.classList.contains('ct-zoom')) return;
            var r = s.getBoundingClientRect();
            s.querySelector('img').style.transformOrigin = ((ev.clientX - r.left) / r.width * 100) + '% ' + ((ev.clientY - r.top) / r.height * 100) + '%';
          });
        });
      }
      minis.forEach(function (m, k) { m.addEventListener('click', function () { irA(k); }); });

      /* Abrir la galería en la foto de la opción elegida (p. ej. al venir del catálogo) */
      var mediaInicial = pdp.getAttribute('data-ct-media-inicial');
      if (mediaInicial && slides && /[?&]variant=/.test(window.location.search)) {
        var idxInicial = Array.prototype.findIndex.call(slides.children, function (s) { return s.getAttribute('data-media-id') === mediaInicial; });
        if (idxInicial > 0) requestAnimationFrame(function () { irA(idxInicial, false); });
      }
      var prev = pdp.querySelector('[data-ct-prev]');
      var next = pdp.querySelector('[data-ct-next]');
      if (prev) prev.addEventListener('click', function () { irA(actual() - 1); });
      if (next) next.addEventListener('click', function () { irA(actual() + 1); });

      /* Variantes */
      var datos = pdp.querySelector('[data-ct-variantes]');
      var variantes = datos ? JSON.parse(datos.textContent) : [];
      var formato = pdp.getAttribute('data-ct-formato');
      var inputId = pdp.querySelector('form[action*="/cart/add"] input[name="id"]');
      var boton = pdp.querySelector('.ct-pdp__boton');
      var botonTexto = boton ? boton.querySelector('[data-ct-boton-texto]') : null;
      var botonPrecio = boton ? boton.querySelector('[data-ct-boton-precio]') : null;
      var precioEl = pdp.querySelector('[data-ct-precio]');
      var antesEl = pdp.querySelector('[data-ct-antes]');
      var ahorroEl = pdp.querySelector('[data-ct-ahorro]');
      var barraPrecio = document.querySelector('[data-ct-barra-precio]');
      var txtAgotado = pdp.getAttribute('data-ct-agotado') || 'Agotado';
      var txtComprar = pdp.getAttribute('data-ct-comprar') || 'Añadir al carrito';

      function opcionesSeleccionadas() {
        return Array.prototype.map.call(pdp.querySelectorAll('[data-ct-opcion]'), function (fs) {
          var c = fs.querySelector('input:checked');
          return c ? c.value : null;
        });
      }
      function actualizar() {
        var sel = opcionesSeleccionadas();
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === sel[i]; });
        });
        if (!v) return;
        if (inputId) inputId.value = v.id;
        if (precioEl) precioEl.textContent = formatearDinero(v.price, formato);
        if (botonPrecio) botonPrecio.textContent = formatearDinero(v.price, formato);
        if (barraPrecio) barraPrecio.textContent = formatearDinero(v.price, formato);
        var hayOferta = v.compare_at_price && v.compare_at_price > v.price;
        if (antesEl) { antesEl.hidden = !hayOferta; if (hayOferta) antesEl.textContent = formatearDinero(v.compare_at_price, formato); }
        if (ahorroEl) { ahorroEl.hidden = !hayOferta; if (hayOferta) ahorroEl.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; }
        if (boton) {
          if (v.available) { boton.removeAttribute('disabled'); boton.removeAttribute('aria-disabled'); if (botonTexto) botonTexto.textContent = txtComprar; }
          else { boton.setAttribute('disabled', 'disabled'); if (botonTexto) botonTexto.textContent = txtAgotado; }
        }
        if (v.featured_media && slides) {
          var idx = Array.prototype.findIndex.call(slides.children, function (s) { return s.getAttribute('data-media-id') === String(v.featured_media.id); });
          if (idx > -1) irA(idx);
        }
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      }
      pdp.querySelectorAll('[data-ct-opcion] input').forEach(function (inp) { inp.addEventListener('change', actualizar); });

      /* Cantidad */
      var cant = pdp.querySelector('[data-ct-cantidad]');
      var cantForm = pdp.querySelector('form[action*="/cart/add"] input[name="quantity"]');
      if (cant) {
        var inp = cant.querySelector('input');
        var sync = function () { var n = Math.max(1, parseInt(inp.value, 10) || 1); inp.value = n; if (cantForm) cantForm.value = n; };
        cant.querySelector('[data-ct-menos]').addEventListener('click', function () { inp.value = (parseInt(inp.value, 10) || 1) - 1; sync(); });
        cant.querySelector('[data-ct-mas]').addEventListener('click', function () { inp.value = (parseInt(inp.value, 10) || 1) + 1; sync(); });
        inp.addEventListener('change', sync);
      }

      /* Barra fija de compra */
      var barra = document.querySelector('[data-ct-barra]');
      if (barra && boton && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            var debajo = e.boundingClientRect.top < 0;
            barra.classList.toggle('ct-visible', !e.isIntersecting && debajo);
          });
        });
        io.observe(boton);
        var btnBarra = barra.querySelector('[data-ct-barra-boton]');
        if (btnBarra) btnBarra.addEventListener('click', function () {
          if (boton.hasAttribute('disabled')) { boton.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
          boton.click();
        });
      }
    });
  }

  /* ---------- Pack: añadir varios productos de una vez ---------- */
  function initPack(raiz) {
    raiz.querySelectorAll('[data-ct-pack]').forEach(function (btn) {
      if (btn.__ctPack) return;
      btn.__ctPack = true;
      btn.addEventListener('click', function () {
        var ids = (btn.getAttribute('data-ct-pack') || '').split(',').filter(Boolean);
        if (!ids.length) return;
        var error = btn.parentElement.querySelector('.ct-pack__error');
        var texto = btn.querySelector('[data-ct-pack-texto]');
        var original = texto ? texto.textContent : '';
        btn.classList.add('ct-cargando');
        if (texto) texto.textContent = 'Añadiendo…';
        if (error) error.hidden = true;
        var drawer = document.querySelector('cart-drawer');
        var cuerpo = { items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) };
        if (drawer) { cuerpo.sections = 'cart-drawer,cart-icon-bubble'; cuerpo.sections_url = window.location.pathname; }
        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(cuerpo)
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) throw new Error(res.description || res.message || 'No se pudo añadir');
            if (drawer && res.sections) {
              drawer.classList.remove('is-empty');
              drawer.renderContents(res);
            } else {
              window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            }
          })
          .catch(function (e) {
            if (error) { error.textContent = e.message; error.hidden = false; }
          })
          .finally(function () {
            btn.classList.remove('ct-cargando');
            if (texto) texto.textContent = original;
          });
      });
    });
  }

  /* ---------- Arranque ---------- */
  function init(raiz) {
    raiz = raiz || document;
    partirTexto(raiz);
    initReveals(raiz);
    initParallax(raiz);
    initVitamina(raiz);
    initTilt(raiz);
    initMagnetico(raiz);
    initAcordeones(raiz);
    initProducto(raiz);
    initPack(raiz);
    alScroll();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* Editor de Shopify: re-inicializar al editar secciones */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest('.ct-faq__item');
    if (item && !item.classList.contains('ct-abierto')) { var b = item.querySelector('.ct-faq__pregunta'); if (b) b.click(); }
    e.target.querySelectorAll && e.target.querySelectorAll('[data-ct-reveal],[data-ct-split],[data-ct-unveil]').forEach(function (el) { el.classList.add('ct-visible'); });
    if (e.target.matches && e.target.matches('[data-ct-reveal],[data-ct-unveil]')) e.target.classList.add('ct-visible');
  });
})();
